import ajax from './ajax';
import { API_DOMAIN } from '../utils/constants';
export async function googleSheets(action, data = {}) {
  const response = await ajax(`${API_DOMAIN}/api/a/google-sheets-${action}`, data, 'POST', true);
  if (response.code && Number(response.code) !== 200) throw new Error(response.msg || 'Request failed.');
  return response.data;
}

let pickerScript;
export function googlePickerOrigin(browserWindow = window, referrer = document.referrer) {
  if (browserWindow.top === browserWindow) return browserWindow.location.origin;
  // Google requires the top-level origin, including when Shopify embeds the app.
  const ancestors = browserWindow.location.ancestorOrigins;
  if (ancestors?.length) return ancestors[ancestors.length - 1];
  try { return browserWindow.top.location.origin; } catch (_) { /* Cross-origin parent. */ }
  if (referrer) return new URL(referrer).origin;
  throw new Error('Could not identify the parent page for Google file picker.');
}
export async function pickGoogleSheet(credentials) {
  if (!pickerScript) pickerScript = new Promise((resolve, reject) => {
    if (window.gapi) { resolve(); return; }
    const script = document.createElement('script'); script.src = 'https://apis.google.com/js/api.js';
    script.onload = resolve; script.onerror = () => { pickerScript = null; reject(new Error('Could not load Google file picker.')); };
    document.head.appendChild(script);
  });
  await pickerScript;
  await new Promise((resolve, reject) => window.gapi.load('picker', { callback: resolve, onerror: reject, timeout: 10000, ontimeout: () => reject(new Error('Google file picker timed out.')) }));
  return new Promise(resolve => {
    const picker = new window.google.picker.PickerBuilder()
      .addView(new window.google.picker.DocsView(window.google.picker.ViewId.SPREADSHEETS))
      .setOAuthToken(credentials.access_token).setDeveloperKey(credentials.api_key).setAppId(credentials.app_id)
      .setOrigin(googlePickerOrigin()).setCallback(data => {
        if (data.action === window.google.picker.Action.PICKED) { resolve({ id: data.docs[0].id, name: data.docs[0].name }); picker.dispose(); }
        if (data.action === window.google.picker.Action.CANCEL) { resolve(null); picker.dispose(); }
      }).build();
    picker.setVisible(true);
  });
}
